import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildIAMAccountEntity } from "@youm-front/iam-account/util/factory";
import {
  IAM_ACCOUNTS_FEATURE_KEY,
  IAMAccountsState,
  iamAccountsAdapter
} from "../reducers";

const { selectAll } = iamAccountsAdapter.getSelectors();

const iamAccountsState = createFeatureSelector<IAMAccountsState>(
  IAM_ACCOUNTS_FEATURE_KEY
);

export const isLoading = createSelector(
  iamAccountsState,
  (state: IAMAccountsState) => state.isLoading
);

export const iamAccounts = createSelector(
  iamAccountsState,
  (state: IAMAccountsState) =>
    selectAll(state).map((_) => buildIAMAccountEntity(_))
);
